export const getTeamSettings = (team) => ({
    suppressNotifications: team?.suppressNotifications,
    minimumMembersToBeReady: team?.minimumMembersToBeReady,
    vacationLimit: team?.vacationLimit,
    submitReadiness: team?.submitReadiness,
});

export const getTeamPtoLimit = (team) => {
    return team?.vacationLimit;
};

export const teamSubmitsReadiness = (team) => team?.submitReadiness === true;

export const describeYesNo = (value) => (value ? 'Yes' : 'No');

export const isNonNegativeInteger = (value) =>
    /^\d+$/.test(String(value).trim()) && Number.isSafeInteger(Number(value));